import { Component,OnInit  } from '@angular/core';
import { Usuario } from '../../entities/usuario';
import { NavParams,LoadingController,ToastController,NavController } from 'ionic-angular';
import { PedidoDAO } from '../../daos/pedido-dao';
import { DTOListaCatalogo } from '../../dto/dtoListaCatalogo';
import { FinalizacaoPedidoPage } from '../../pages/finalizacao-pedido/finalizacao-pedido';
import { DTOTam } from '../../dto/dtoTam';
import { VisualizaImagemPage } from '../../pages/visualiza-imagem/visualiza-imagem';
import { ItemPedido } from '../../entities/ItemPedido';

import _ from 'lodash';

@Component({
    selector: 'page-lista-brinde',
    templateUrl: 'lista-brinde.html'
})
export class ListaBrindePage implements OnInit  {
    public usuario: Usuario;
    public itemPedido: ItemPedido = new ItemPedido();
    public listaCatalogo: DTOListaCatalogo[] = [];
    public listaCatalogoOriginal: DTOListaCatalogo[] = [];
    public listaTamanho: DTOTam[] = [];
    public tamSelecionado: DTOTam = null;
    public qtdePicote: number;
    public selCodigo: number;
    public nomeIIS: string;
    public dtoCarrinho: DTOTam[]= [];
    public mostrarAddCarrinho: boolean = false;
    public mostrarFazerPedido: boolean = false;
    searchTerm: string;

    constructor(private _loadingCtrl: LoadingController,private _navCtrl: NavController,_navParams: NavParams,
        private _toastCtrl: ToastController,
        private _pedidoDAO: PedidoDAO) {
        this.qtdePicote = _navParams.get('qtdePicote');
        this.usuario = _navParams.get('usu');
    }

    ngOnInit(): void {
        let load = this._loadingCtrl.create({ content: 'Obtendo catalogo...' });
        load.present();
        this._pedidoDAO.listaCatalogoPorPicote(this.usuario.Empresa.Id, this.qtdePicote).then(lista => {        
        //lista = lista.filter(item => _.isEqual(item.QtdePicote, this.qtdePicote));  
        this.listaCatalogoOriginal =  lista;
        this.listaCatalogo = this.listaCatalogoOriginal;

        load.dismiss();
        }).catch(error => {
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao tentar obter catalogo. Tente novamente!',
            duration: 3000
        }).present();
        console.error(error);
        load.dismiss();
        });        
    }

    selectCor(event, referencia: string){
        this.tamSelecionado = null;
        this.listaCatalogo = this.listaCatalogo.filter(item => _.isEqual(item.Referencia, referencia));    

        this.listaCatalogo.forEach( lstCor => {
            lstCor.DTOCor.forEach(lstTam=>{
                if (lstTam.Codigo == event) {
                    this.listaTamanho = lstTam.DTOTam;
                }                
            })
   
          });
    }

    selectTam(selection){
        this.listaTamanho.forEach( lstTam => {
            if (lstTam.Codigo == selection) {
                this.tamSelecionado = lstTam;
                this.mostrarAddCarrinho = true;
                this.mostrarFazerPedido = false;
            }                   
          });        
    }

    adicionarItem(obj:DTOTam){        
        this.dtoCarrinho.push(obj);

        this.mostrarAddCarrinho = false;
        this.mostrarFazerPedido = false;
        if (obj.Grupo == 'CALCINHA'){
            this.listaCatalogo = this.listaCatalogoOriginal; 
            this.listaCatalogo = this.listaCatalogo.filter(item => 
                _.isEqual(item.Grupo, 'SUTIA') ||
                _.isEqual(item.Grupo, 'CALCINHA')
            
            );    
        } else if (obj.Grupo == 'SUTIA'){
            this.listaCatalogo = this.listaCatalogoOriginal; 
            this.listaCatalogo = this.listaCatalogo.filter(item => _.isEqual(item.Grupo, 'CALCINHA'));    
            
        } else{
            this.listaCatalogo = this.listaCatalogoOriginal; 
            this.listaCatalogo = this.listaCatalogo.filter(item => _.isEqual(item.Grupo, 'ESPECIAL'));
            this.listaCatalogo = [];
            this.mostrarFazerPedido = true;
        }

         
        
        if  (this.dtoCarrinho.length == 2){
            this.listaCatalogo = [];
            this.mostrarFazerPedido = true;
        }
           
    }

    fazerPedido(){
        //this.itemPedido.Empresa = AppModule.getEmpresa();
        //this.itemPedido.RedProdutoKey = obj.Codigo; 
        //AppModule.lstDTOTam = this.dtoCarrinho;
        this._navCtrl.push(FinalizacaoPedidoPage,{usu: this.usuario, carrinho:this.dtoCarrinho,qtdePicote:this.qtdePicote});  
    }

    delItem(item){
        const index = this.dtoCarrinho.indexOf(item);
        this.dtoCarrinho.splice(index, 1);
       // const elementoRemovido = this.dtoCarrinho.splice(index, 1);
        // aqui podes fazer algo com o item removido
        // a array modifica-se a si própria com o splice

        this.mostrarAddCarrinho = false;
        this.mostrarFazerPedido = false;
        let grupoCarrinho ;

        if  (this.dtoCarrinho.length == 0){
            this.listaCatalogo = this.listaCatalogoOriginal; 
        }else if  (this.dtoCarrinho.length == 1){
            this.dtoCarrinho.forEach( vGrupo => {
                grupoCarrinho = vGrupo.Grupo;
       
            });
            //console.log(item.Grupo);
            if (grupoCarrinho == 'CALCINHA'){
                this.listaCatalogo = this.listaCatalogoOriginal; 
                this.listaCatalogo = this.listaCatalogo.filter(item => 
                    _.isEqual(item.Grupo, 'SUTIA') ||
                    _.isEqual(item.Grupo, 'CALCINHA')
                
                ); 
            }else if(grupoCarrinho == 'SUTIA'){
                this.listaCatalogo = this.listaCatalogoOriginal; 
                this.listaCatalogo = this.listaCatalogo.filter(item => _.isEqual(item.Grupo, 'CALCINHA'));    
                
            }
        
        }
     }

    visualizarImagem(obj:string){     
        this._navCtrl.push(VisualizaImagemPage,{usu: this.usuario, img: obj  });
    }





}


// WEBPACK FOOTER //
// ./src/pages/lista-brinde/lista-brinde.ts